<script setup lang="ts">
import { onMounted } from 'vue'

import ogImage from '@/assets/images/oldcastle_logomark.png'
import Notice from '@/components/small/Notice.vue'

onMounted(() => {
  const title = 'Oldcastle | Online Contractor Orientation'
  const description =
    'For us at Oldcastle Infrastructure, safety is a core value. Our goal is to achieve ZERO HARM at our sites to ensure all individuals go home in the same condition in which they arrived. We protect each other, look out for one another, and when we see something, we stop and do something.'

  document.title = title
  document.querySelector('meta[name="og:title"]')?.setAttribute('content', title)
  document.querySelector('meta[name="og:image"]')?.setAttribute('content', ogImage)
  document.querySelector('meta[name="description"]')?.setAttribute('content', description)
  document.querySelector('meta[name="og:description"]')?.setAttribute('content', description)
})
</script>

<template>
  <Notice />
  <RouterView />
</template>
